import { Component } from "@angular/core";

@Component({
    selector: 'app-pqrPqrsHome',
    templateUrl: './pqrPqrsHome.component.html',
    styleUrls: ['./pqrPqrsHome.component.css']
})
export class PqrPqrsHomeComponent{
    constructor(){}
}